export { default } from './search-results-content.component';
